import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Heading1 from '../titles/Heading1';
import { Col } from 'react-bootstrap';
import VisibilitySensor from 'react-visibility-sensor';

class BlockEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : ['animate-box'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes });
            }
        }
    };      
    render() {
        const props = this.props;
        return (
                <Col md={8} >
                    <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                        <div key={ props.content.title } className={"blog-article-container "+props.className} style={props.style}>

                                <div className="tags">
                                    <h4><i className="fa fa-tag"></i>{props.content.tags}</h4>
                                </div>
                                <div className="title">
                                    <Heading1 title={ props.content.title } />
                                    <div className="entry-details">
                                        <span className="author"><i className="fa fa-user"></i>{ props.content.author }</span>
                                        <span className="date"><i className="fa fa-calendar"></i>{ props.content.date }</span>
                                    </div>
                                </div>
                                
                                <div className="body">
                                    { props.translate(props.content.long_entry) }
                                </div>  
                        </div>
                    </VisibilitySensor>  
                </Col>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(BlockEntry);





// WEBPACK FOOTER //
// ./src/components/aside/articleblockentry.jsx